export default __webpack_public_path__ + "static/logoExpLight-6e5e2080f6ffdebac17b5b2ac7b03ef3.png";